import { GEOSPATIAL_LAT_LON_DELIMITER } from "Common/componentUtils/constants";
export default {
    FORMAT_ERROR_MESSAGE: "Неверный формат ввода",
    TOOLTIP: `Широта (от -90 до +90)${GEOSPATIAL_LAT_LON_DELIMITER}долгота (от -180 до +180)\nНапример,\n55.7522${GEOSPATIAL_LAT_LON_DELIMITER}37.6156`
};
